import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Header } from '../components/Header';
import { useAuthContext } from '../contexts/AuthContext';
import { usePermissionStore } from '../lib/permissions';
import { usePermissions } from '../lib/permissions';
import { LaneOperatingHoursCalendar } from '../components/admin/LaneOperatingHours/LaneOperatingHoursCalendar';

export const CalendarPanel: React.FC = () => {
  const navigate = useNavigate();
  const { user, isAuthenticated, isLoading } = useAuthContext();
  const { currentUser } = usePermissionStore();
  const permissions = usePermissions();

  React.useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login');
      return;
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading state while authentication is being determined
  if (isLoading || isAuthenticated === null) {
    return (
      <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white mx-auto mb-4"></div>
          <p className="text-gray-400">Loading authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect unauthenticated users
  if (!isAuthenticated) {
    return null; // Will redirect to login
  }



  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Header />
      
      <main className="p-4 lg:p-6">
        <div className="max-w-full mx-auto">
          <LaneOperatingHoursCalendar />
        </div>
      </main>
    </div>
  );
};
